import 'semantic-ui-css/semantic.min.css';
import "./assets/css/App.css";
import './assets/css/Tabler.css';
import './assets/css/Demo.css';
import './assets/css/ThemeTransitions.css';
import './assets/css/LightModeEnhancements.css';
import './assets/css/ClubPanel.css';
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { DateFilterProvider } from './contexts/DateFilterContext';
import { EarningsVisibilityProvider } from './contexts/EarningsVisibilityContext';
import TopBar from './Components/TopBar';
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Home from "./Pages/Home";
import Login from './Pages/Auth/Login';
import Club from "./Pages/Club";
import TableStats from './Pages/Stats/TableStats';
import GameStats from './Pages/Stats/GameStats';
import SnookerStats from './Pages/Stats/SnookerStats';
import Games from './Pages/Games';
import FinishedGames from './Pages/FinishedGames';
import GameDetails from './Pages/GameDetails';
import Players from './Pages/Players';
import ScoreBoard from './Pages/Scoreboard';
import Streaming from './Pages/Streaming';
import QueueManagement from './Pages/QueueManagement';
import PublicQueue from './Pages/PublicQueue';
import AllTablesQueueManagement from "./Pages/AllTablesQueueManagement";
import SettingsPage from "./Pages/SettingsPage";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import GeneralConditions from "./Pages/GeneralConditions";
import Pricing from "./Pages/Pricing";
import PlayerDisplay from './Pages/PlayerDisplay';
import GameWrapper from './Pages/GameWrapper';
import TvConnect from './Pages/TvConnect';
import ClubRoute from './Components/ClubRoute';
import { getRouteLayout } from './utils/routeLayout';

function AppContent() {
	const location = useLocation();
	const { user } = useAuth();
	const { isClubPanelPage, showClubHeader, showFooter } = getRouteLayout(location.pathname, !!user);

	return (
			<div className={`page page-center${isClubPanelPage ? ' club-panel-shell' : ''}`}>
			{showClubHeader && <TopBar />}
			{showClubHeader && <Header />}
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/login" element={<Login />} />
				<Route element={<ClubRoute />}>
					<Route path="/club" element={<Club />} />
					<Route path="/table/stats/:id" element={<TableStats />} />
					<Route path="/game/stats/:id" element={<GameStats />} />
					<Route path="/stats/snooker" element={<SnookerStats />} />
					<Route path="/games" element={<Games />} />
					<Route path="/games/finished" element={<FinishedGames />} />
					<Route path="/game/:id" element={<GameDetails />} />
					<Route path="/players" element={<Players />} />
					<Route path="/queue/:id" element={<QueueManagement />} />
					<Route path="/queues/all/:club_id" element={<AllTablesQueueManagement />} />
					<Route path="/settings/:club_id?" element={<SettingsPage />} />
					<Route path="/tv-connect" element={<TvConnect />} />
				</Route>
				<Route path="/play/:type/:id/:view" element={<GameWrapper />} />
				<Route path="/scoreboard/:type/:id" element={<ScoreBoard />} />
				<Route path="/streaming/:id" element={<Streaming />} />
				<Route path="/public/queue/:club_id" element={<PublicQueue />} />
				<Route path="/privacy-policy" element={<PrivacyPolicy />} />
				<Route path="/general-conditions" element={<GeneralConditions />} />
				<Route path="/pricing" element={<Pricing />} />
				<Route path="/player/:id" element={<PlayerDisplay />} />
			</Routes>
			{showFooter && <Footer />}
		</div>
	);
}

function App() {
	return (
		<div className="App">
			<Router>
				<ThemeProvider>
					<AuthProvider>
                        <EarningsVisibilityProvider>
                            <DateFilterProvider>
                                <AppContent />
                            </DateFilterProvider>
                        </EarningsVisibilityProvider>
					</AuthProvider>
				</ThemeProvider>
			</Router>
		</div>
	);
}

export default App;
